module.exports = __webpack_public_path__ + "img/base_nature_barrage.479731f7.svg";